import { useState, useEffect } from "react";
import styles from "../../styles/addReceipt.module.css";

export function CxcSummary({ handleCurrencyFormat, facturasData, restante }) {
  const [total, setTotal] = useState(0);
  const [favor, setFavor] = useState(0);
  useEffect(() => {
    const sum = facturasData.reduce((acc, inv) => {
      if (Number(inv.abono) > 0) {
        return acc + Number(inv.abono || 0);
      }
      return acc;
    }, 0);
    const favor = facturasData.reduce(
      (acc, inv) => acc + Number(inv.favor || 0),
      0,
    );
    setTotal(sum);
    setFavor(favor);
  }, [facturasData]);
  return (
    <div className={styles["cxc-details-summary"]}>
      <div className={styles["cxc-summary-relevant"]}>
        <h2>RESUMEN RÁPIDO</h2>
        <div className="d-flex justify-content-between align-items-center">
          <span>Total CxC seleccionado</span>
          <span>₡ {handleCurrencyFormat(total)}</span>
        </div>
        <div className="d-flex justify-content-between align-items-center">
          <span>Total Saldo a Favor</span>
          <span>₡ {handleCurrencyFormat(favor)}</span>
        </div>
      </div>
      <div className={styles["cxc-summary-important"]}>
        <h2>Total Restante</h2>
        <span>₡ {handleCurrencyFormat(restante)}</span>
      </div>
    </div>
  );
}
